export default {
  root: {
    // backgroundColor: colors.grey[50]
  }
};
